/** 与登录页一致的品牌 Logo */
export const MERCHANT_LOGO_URL =
  "https://res.cloudinary.com/dtmd7k4sn/image/upload/v1773366154/Frame_1321314936_dzafr2.png";

export const MERCHANT_BRAND_NAME = "dvaplus";
